import * as React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { googleMapsConfig } from 'googleMapsConfig';

type LatLng = { lat: number; lng: number };

type LocationMapProps = {
  value?: LatLng | null;
  defaultCenter?: LatLng;
  zoom?: number;
  readOnly?: boolean;
  height?: number;
  onChange?: (v: LatLng) => void;
  style?: React.CSSProperties;
};

const baseStyle: React.CSSProperties = {
  width: '100%',
  height: 250,
  borderRadius: 16,
  overflow: 'hidden',
};

function isValidLatLng(v?: LatLng | null) {
  return !!v && typeof v.lat === 'number' && typeof v.lng === 'number' && !Number.isNaN(v.lat) && !Number.isNaN(v.lng);
}

export default function LocationMap({
  value,
  defaultCenter = { lat: 13.736717, lng: 100.523186 }, // กทม. เป็นค่า fallback
  zoom = 15,
  readOnly = true,
  height = 250,
  onChange,
  style,
}: LocationMapProps) {
  const { isLoaded } = useJsApiLoader(googleMapsConfig);

  const center = isValidLatLng(value) ? (value as LatLng) : defaultCenter;

  if (!isLoaded) {
    return <img src="/static/components/non_map.png" alt="non map" style={{ ...baseStyle, height }} />;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ ...baseStyle, height, ...style }}
      center={center}
      zoom={zoom}
      onClick={(e) => {
        if (readOnly || !e.latLng) return;
        onChange?.({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      }}
      options={{
        disableDefaultUI: true,
        draggable: !readOnly,
        scrollwheel: !readOnly,
        disableDoubleClickZoom: readOnly,
        gestureHandling: readOnly ? 'none' : 'auto',
      }}
    >
      {isValidLatLng(value) && (
        <Marker
          position={value as LatLng}
          draggable={!readOnly}
          onDragEnd={(e) => {
            if (readOnly || !e.latLng) return;
            onChange?.({ lat: e.latLng.lat(), lng: e.latLng.lng() });
          }}
        />
      )}
    </GoogleMap>
  );
}
